/**
 * Catálogos — los seis maestros de configuración en una sola página.
 *
 * Estaban como seis entradas sueltas en un menú de catorce. Son datos maestros
 * de visita rara, todos de ADMIN, y agruparlos además hace evidente algo que
 * antes había que adivinar: que el Categorizador de gastos depende de las
 * Tipologías. Las rutas antiguas siguen vivas y entran por su pestaña.
 */
import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import ProductsSettingsPage from './Products'
import ServiceLinesSettingsPage from './ServiceLines'
import ExpenseCategoriesSettingsPage from './ExpenseCategories'
import ExpenseRulesSettingsPage from './ExpenseRules'
import AdvisorsSettingsPage from './Advisors'
import ProjectRolesSettingsPage from './ProjectRoles'

const TABS = [
  { key: 'products', path: '/settings/products', Component: ProductsSettingsPage },
  { key: 'serviceLines', path: '/settings/service-lines', Component: ServiceLinesSettingsPage },
  { key: 'expenseCategories', path: '/settings/expense-categories', Component: ExpenseCategoriesSettingsPage },
  { key: 'expenseRules', path: '/settings/expense-rules', Component: ExpenseRulesSettingsPage },
  { key: 'advisors', path: '/settings/advisors', Component: AdvisorsSettingsPage },
  { key: 'projectRoles', path: '/settings/project-roles', Component: ProjectRolesSettingsPage },
] as const

export default function CatalogsSettingsPage() {
  const { t } = useTranslation('settings')
  const location = useLocation()
  const navigate = useNavigate()

  // Si se entra por una ruta antigua (/settings/products…), se abre su pestaña.
  const fromPath = TABS.findIndex((tab) => location.pathname.startsWith(tab.path))
  const [active, setActive] = useState(fromPath >= 0 ? fromPath : 0)

  useEffect(() => {
    if (fromPath >= 0 && fromPath !== active) setActive(fromPath)
    // Normaliza la URL a /settings/catalogs sin perder la pestaña elegida.
    if (fromPath >= 0 && location.pathname !== '/settings/catalogs') {
      navigate('/settings/catalogs', { replace: true })
    }
  }, [fromPath, active, location.pathname, navigate])

  const Active = TABS[active]!.Component

  return (
    <div className="space-y-4">
      <div>
        <h2 className="text-2xl font-serif font-semibold t-primary">{t('nav.catalogs')}</h2>
        <p className="t-muted text-sm mt-1">{t('catalogs.subtitle')}</p>
      </div>

      <div className="flex flex-wrap gap-1 border-b" style={{ borderColor: 'var(--border)' }}>
        {TABS.map((tab, i) => (
          <button
            key={tab.key}
            type="button"
            onClick={() => setActive(i)}
            className={[
              'px-3 py-2 text-sm -mb-px border-b-2 transition',
              i === active
                ? 'border-jr2-500 text-jr2-700 dark:text-jr2-200 font-medium'
                : 'border-transparent t-muted hover:t-primary',
            ].join(' ')}
          >
            {t(`catalogs.tabs.${tab.key}`)}
          </button>
        ))}
      </div>

      <Active />
    </div>
  )
}
